(() => {
  const LEGACY_COPY_REPLACEMENTS = [
    [
      'All orders are shipped within 7-10 business days.',
      'Delivery options, costs and estimated timescales are shown at checkout. Standard in-stock orders are typically prepared within 3–14 business days, depending on stock, product type and transport logistics.'
    ],
    [
      'All orders are shipped within 7–10 business days.',
      'Delivery options, costs and estimated timescales are shown at checkout. Standard in-stock orders are typically prepared within 3–14 business days, depending on stock, product type and transport logistics.'
    ],
    [
      'We offer a 30 day guarantee on all orders for returns/refunds so long as they meet our returns policy.',
      'Returns depend on the product and reason for return. Please review our Returns & Refunds Policy before returning an item. Your statutory rights are unaffected.'
    ],
    [
      'We offer a 30 day guarantee on all orders for returns/refunds so long as they meet our returns policy',
      'Returns depend on the product and reason for return. Please review our Returns & Refunds Policy before returning an item. Your statutory rights are unaffected.'
    ],
    [
      'We offer a 30 day guarantee on all orders for returns/refunds',
      'Returns depend on the product and reason for return. Please review our Returns & Refunds Policy before returning an item. Your statutory rights are unaffected.'
    ]
  ];

  const normaliseLegacyProductCopy = () => {
    const productSection = document.querySelector('.shopify-section--main-product');
    if (!productSection) return;

    const walker = document.createTreeWalker(productSection, NodeFilter.SHOW_TEXT);
    const textNodes = [];

    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    textNodes.forEach((node) => {
      if (node.parentElement?.closest('script, style, noscript, template')) return;

      let text = node.nodeValue || '';
      let updated = text;

      LEGACY_COPY_REPLACEMENTS.forEach(([from, to]) => {
        if (updated.includes(from)) {
          updated = updated.split(from).join(to);
        }
      });

      updated = updated.replace(/\+440800\s*1577574/g, '0800 157 7574');

      if (updated !== text) {
        node.nodeValue = updated;
      }
    });

    productSection.querySelectorAll('a[href^="tel:"]').forEach((link) => {
      const href = link.getAttribute('href') || '';
      const visible = link.textContent || '';

      if (!href.includes('+440800') && !visible.includes('+440800')) return;

      link.href = 'tel:+448001577574';
      link.textContent = visible.replace(/\+440800\s*1577574/g, '0800 157 7574');
    });
  };

  const installOffer = () => {
    const productSection = document.querySelector('.shopify-section--main-product');
    if (!productSection) return;

    normaliseLegacyProductCopy();

    const source = document.querySelector('[data-ph-pdp-offer-source]');
    if (!source) return;

    const blockList = productSection.querySelector('.product-info__block-list');
    if (!blockList || blockList.querySelector('[data-ph-pdp-current-offer]')) return;

    const target =
      blockList.querySelector('.product-info__block-item[data-block-type="variant-picker"]') ||
      blockList.querySelector('.product-info__block-item[data-block-type="quantity-selector"]') ||
      blockList.querySelector('.product-info__block-item[data-block-type="buy-buttons"]');

    if (!target) return;

    const offer = source.firstElementChild?.cloneNode(true);
    if (!offer) return;

    target.before(offer);
  };

  const start = () => {
    installOffer();

    const productSection = document.querySelector('.shopify-section--main-product');
    if (!productSection) return;

    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(() => {
        queued = false;
        installOffer();
      });
    });

    observer.observe(productSection, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
